"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

const index_1 = require("../../../index");

const AbstractTimeExpressionParser_1 = require("../../../common/parsers/AbstractTimeExpressionParser");

class ENTimeExpressionParser extends AbstractTimeExpressionParser_1.AbstractTimeExpressionParser {
  constructor(strictMode) {
    super(strictMode);
  }

  followingPhase() {
    return "\\s*(?:\\-|\\–|\\~|\\〜|to|\\?)\\s*";
  }

  primaryPrefix() {
    return "(?:(?:at|from)\\s*)??";
  }

  primarySuffix() {
    return "(?:\\s*(?:o\\W*clock|at\\s*night|in\\s*the\\s*(?:morning|afternoon)))?(?!/)(?=\\W|$)";
  }

  extractPrimaryTimeComponents(context, match) {
    const components = super.extractPrimaryTimeComponents(context, match);

    if (components) {
      if (match[0].endsWith("night")) {
        const hour = components.get("hour");

        if (hour >= 6 && hour < 12) {
          components.assign("hour", components.get("hour") + 12);
          components.assign("meridiem", index_1.Meridiem.PM);
        } else if (hour < 6) {
          components.assign("meridiem", index_1.Meridiem.AM);
        }
      }

      if (match[0].endsWith("afternoon")) {
        components.assign("meridiem", index_1.Meridiem.PM);
        const hour = components.get("hour");

        if (hour >= 0 && hour <= 6) {
          components.assign("hour", components.get("hour") + 12);
        }
      }

      if (match[0].endsWith("morning")) {
        components.assign("meridiem", index_1.Meridiem.AM);
        const hour = components.get("hour");

        if (hour < 12) {
          components.assign("hour", components.get("hour"));
        }
      }
    }

    return components;
  }

}

exports.default = ENTimeExpressionParser;